import Tips from './Tips'
import {isnull} from './tools'

export const ResultCode = {
  Success: 0,
  AnchorOffLine: -2,  // 主播在线但是应用被关闭
  AnchorBusy: -3,    // busy
  AnchorDontDisturb: -4,   // offline
  RoomIdError: -5,
  AlreadyBlack: -9,  // 该账号已在黑名单
  MaxPhotoNum: -11,  // 达到相册相片最大数量
  AlreadyApply: -13, // 已经在申请
  HostIdError: -17,  // 主播Id有误
  AnchorIdError: -18,  // 主播Id有误
  NoCoin: -25, // 金币不足
  NameExist: -28,  // 账户名已存在
  NameNotExist: -31,   // 账户名不存在
  PwdError: -32, // 密码有误
  AnchorLogout: -37,  // 未登陆
  ReceiptCantBeNull: -40,  // 充值单据不能为空
  ReceiptExist: -41, // 单据已存在
  ReceiptVerifyFail: -42,   // 单据验证失败
  RegionCodeInvalid: -43,   // 区域格式错误
  RetDeviceIsBanned: -44,  // 设备已封
  InObjsBlack: -45,  // 在对方的黑名单中
  ObjInUrBlacklist: -46,   // 对方在自己的黑名单中
  AccountBlocked: -47,      // 账号被封
  MaleNoAnchor: 49,   // 男人不能申请主播
  NotFollowYet: -52,   // 还未关注对方
  AlreadyFollow: -53,   // 已关注
  LanguageNosup: -61,  //当前语言不支持
  AlreadyHasBoss: -78,   // 已经有boss了
  ForceDownMic: -82,  // 强制下麦中
  SessionInvalid: -83,   // Session失效
  SessionNotFound: -84,    // Session未找到
  SessionExpired: -85,  // Session过期
  MaxAccountNum: -89,  //达到设备最大账号数
  O2oNoBoss: -98,    // 1对多房间禁止操作
  O2mHostHasBeenTaken: -102, // 主播人已经被带走
  OperationToMany: -109,  // 操作太频繁
  MomentNotExist:-124,
  CommentNotExist:-125,
  AnchorClosePrivate:-129,//语聊房主播关闭带走
  LoginAsAnchor:-146,
  RoleNotSupport: -150,//不支持主播登录

  NO_NETWORK: -1000,
}

export default class TipsUtils {
  static getErrorTips (code) {
    // let e = Tips.e_internet
    let e = ''
    switch (code) {
      case ResultCode.AnchorDontDisturb :
        e = Tips.e_dontDisturb
        break

      case ResultCode.AlreadyBlack :
        e = Tips.e_already_black
        break

      case ResultCode.AnchorLogout:
      case ResultCode.AnchorOffLine :
        e = Tips.e_logout
        break

      case ResultCode.AnchorBusy :
        e = Tips.e_busy
        break

      case ResultCode.O2oNoBoss :
        e = code.toString()
        break

      case ResultCode.ForceDownMic :
        e = Tips.e_force_down_mic
        break

      case ResultCode.AlreadyHasBoss :
        e = Tips.e_has_boss
        break

      // 不能让用户察觉错误
      case ResultCode.RegionCodeInvalid:
      case ResultCode.LanguageNosup :
        e += ResultCode.LanguageNosup
        break

      case ResultCode.MaxPhotoNum :
        e = Tips.e_max_photo
        break

      case ResultCode.AlreadyApply :
        e = Tips.e_already_apply
        break

      case ResultCode.NameExist :
        e = Tips.e_email_exists
        break

      case ResultCode.NameNotExist :
        e = Tips.e_name_not_exists
        break

      case ResultCode.PwdError:
        e = Tips.e_pwd
        break

      case ResultCode.ReceiptCantBeNull:
      case ResultCode.ReceiptExist:
      case ResultCode.ReceiptVerifyFail:
        e = Tips.e_fail_recharge
        break

      case ResultCode.RetDeviceIsBanned:
        e = Tips.e_block
        break

      case ResultCode.InObjsBlack:
        e = Tips.e_been_black
        break

      case ResultCode.ObjInUrBlacklist:
        e = Tips.e_block_by_you
        break

      case ResultCode.MaleNoAnchor:
        e = Tips.e_male_no_anchor
        break

      case ResultCode.NotFollowYet:
        e = Tips.e_not_follow
        break

      case ResultCode.AlreadyFollow:
        e = Tips.e_already_follow
        break

      case ResultCode.MaxAccountNum:
        e = Tips.e_max_account
        break
      case ResultCode.AccountBlocked:
        e = 'This account has been blocked!'
        break
      case ResultCode.RoleNotSupport:
        e = Tips.error_role_not_support
        break
      case ResultCode.NoCoin:
        e = Tips.remind_recharge
        break
      case ResultCode.RoomIdError:
        e = Tips.room_close
        break
      case ResultCode.AnchorClosePrivate:
        e=Tips.e_anchor_close_private
        break
      case  ResultCode.NO_NETWORK:
        e = Tips.e_no_network
        break
      case ResultCode.MomentNotExist:
        e=Tips.e_moment_has_been_deleted
        break
      case ResultCode.CommentNotExist:
        e=Tips.e_comment_has_been_deleted
        break
      case ResultCode.LoginAsAnchor:
        e=Tips.e_illegal_as_anchor
        break
      case ResultCode.AnchorIdError:
        e=Tips.e_error_anchor_id
        break
      case ResultCode.HostIdError:
        e=Tips.e_error_host_id
        break
      case ResultCode.O2mHostHasBeenTaken:
        e=Tips.e_host_took
        break

    }
    if (isnull(e)) {
      e = code
    }
    return e
  }
}



// WEBPACK FOOTER //
// ./src/utils/TipsUtils.js